import React from 'react'
import theme from '../../../utils/mui-theme'

function JobDetailsModal({
  jobTitle,
  setJobTitle,
  selectedATS,
  setSelectedATS,
  isEdit
}) {
  const atsOptions = [
    { value: 'none', label: 'Manual Entry' },
    { value: 'zoho', label: 'Zoho Recruit' }
  ]

  return (
    <div className="flex flex-col gap-5 px-5 sm:px-14 pt-8 py-10">
      <div className='flex flex-col gap-2'>
        <label className="font-bold">Job title</label>
        <input
          type="text"
          value={jobTitle}
          aria-label='Enter the title of the job'
          onChange={(e) => setJobTitle(e.target.value)}
          placeholder="Enter the title of the job"
          className="w-full p-3 border font-medium rounded-md"
          style={{
            borderColor: theme.palette.secondary.v4,
            color: theme.palette.text.dark
          }}
        />
      </div>

      <div className='flex flex-col gap-2'>
        <label className="font-bold">Choose the ATS</label>
        <select
          value={selectedATS}
          aria-label= 'Choose the ATS'
          onChange={(e) => setSelectedATS(e.target.value)}
          className="w-full p-3 border font-medium rounded-md"
          style={{
            borderColor: theme.palette.secondary.v4,
            color: theme.palette.text.dark
          }}
          disabled={isEdit}
          onKeyUp={(e) => {
            if (e.key === 'Enter') {
              e.preventDefault();
              const isExpanded = e.target.getAttribute('aria-expanded') === 'true' || false;
              e.target.setAttribute('aria-expanded', !isExpanded);
              e.target.size = !isExpanded ? e.target.options.length : 1;
            }
            else if (e.key === 'Escape') {
              e.preventDefault();
              e.target.setAttribute('aria-expanded', 'false');
              e.target.size = 1;
            }
          }}
        >
          {!selectedATS && (
            <option value="" hidden style={{color : theme.palette.text.dark}}>
              Select the ATS where job is posted
            </option>
          )}
          {atsOptions.map((option) => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
        </select>

      </div>
    </div>
  )
}

export default JobDetailsModal
